import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@/App.css"
import { useAtom } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { useFetchPersonalInformationByUserId } from '@/data/swrs/useFetchPersonalInformationByUserId';
import { useVerifySubscription } from '@/hook/useVerifySubscription';
import SidebarBottomItems from '@/Layouts/UserLayout/components/SidebarBottomItems';
import SidebarItems from '@/Layouts/UserLayout/components/SidebarItems';

function Sidebar({ closeCallback, isSidebarCollapsed }) {
	const [userData, setUserData] = useAtom(userInfoAtom);
	const apiStatus = useVerifySubscription();
	const { data: userPersonalInfo } = useFetchPersonalInformationByUserId();

	useEffect(() => {
		if (!userPersonalInfo?.userType || userData?.user?.userType === userPersonalInfo.userType) return;

		const updatedUserData = {
			...userData,
			user: { ...userData.user, userType: userPersonalInfo.userType }
		};

		setUserData(updatedUserData);
		localStorage.setItem('userData', JSON.stringify(updatedUserData.user));
	}, [userPersonalInfo, userData?.token]);

	return (
		<div>
			<ul className="nav nav-pills nav-flush flex-column mb-auto">
				<SidebarItems closeCallback={closeCallback} isSidebarCollapsed={isSidebarCollapsed} />
			</ul>
			<ul style={{ marginTop: '1.8rem' }} className="nav nav-pills nav-flush flex-column c-login_manu">
				<SidebarBottomItems apiStatus={apiStatus} isSidebarCollapsed={isSidebarCollapsed} />
			</ul>
		</div>
	);
}

export default Sidebar;
